export default () => ({
  titleCard: {
    marginBottom: 35,
  },
});
